module.exports = __webpack_public_path__ + "img/caseBuilder-productManager.3d7a0fd3.webp";